export default "__VITE_ASSET__09iNpC2L__"